import { createReducer, getUpdater } from '@advanza/advanza_generic'
import { changeEntity, changeFilter, invalidateFilters, receiveList } from './sharedReducerHandlers'

const update = getUpdater()

const handlers = {
    TESTIMONIALS_REQUEST: (state) =>
        update(state, {
            isFetching: { $set: true },
        }),
    TESTIMONIALS_RECEIVE_LIST: receiveList,
    TESTIMONIALS_CHANGE_FILTER: changeFilter,
    CHANGE_ENTITY_TESTIMONIALS: changeEntity,
    INVALIDATE_TESTIMONIALS: invalidateFilters,
}

const initialState = {
    isFetching: false,
    didInvalidate: false,
    entities: {},
    result: {},
    counts: {},
    filters: {},
}

export default createReducer(initialState, handlers)
